export { QRCamera } from "./QRCamera";
